import React from 'react'

export default React.createContext<{
  productFilters: any
  setProductFilters: (value) => void
  filterTypes: any
  setFilterTypes: (value) => void
  priceFilters: any
  setPriceFilters: (value) => void
  getAllFilters: () => any
}>({
  productFilters: [],
  setProductFilters: () => {},
  filterTypes: {},
  setFilterTypes: () => {},
  priceFilters: [],
  setPriceFilters: () => {},
  getAllFilters: () => {}
})
